import React, { useState } from 'react';
import { CalendarIcon, UsersIcon, HomeIcon, PlusIcon, CreditCardIcon, CheckCircleIcon, XIcon, ClockIcon, InfoIcon } from 'lucide-react';
import Header from '../components/Header';
const Bookings = () => {
  // Genereer een realistische boeking
  const [booking] = useState({
    id: 'OC-' + Math.floor(10000 + Math.random() * 90000),
    arrivalDate: '2023-08-12',
    departureDate: '2023-08-19',
    persons: 5,
    accommodation: 'Safaritent met sanitair',
    location: 'Standplaats 42',
    price: 595,
    deposit: 150,
    status: 'confirmed',
    extras: [{
      name: 'Koelkast',
      price: 25
    }, {
      name: 'Elektriciteit',
      price: 35
    }, {
      name: 'Eindschoonmaak',
      price: 45
    }],
    payments: [{
      date: '2023-05-15',
      amount: 150,
      type: 'deposit'
    }, {
      date: '2023-07-20',
      amount: 550,
      type: 'final'
    }]
  });
  const [showExtras, setShowExtras] = useState(false);
  // Bereken totale prijs
  const totalExtras = booking.extras.reduce((sum, extra) => sum + extra.price, 0);
  const totalPrice = booking.price + totalExtras;
  // Formateer datums
  const formatDate = dateString => {
    const options = {
      weekday: 'short',
      day: 'numeric',
      month: 'long'
    };
    return new Date(dateString).toLocaleDateString('nl-NL', options);
  };
  const arrivalDate = formatDate(booking.arrivalDate);
  const departureDate = formatDate(booking.departureDate);
  // Bereken verblijfsduur
  const calculateDuration = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffTime = endDate - startDate;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };
  const duration = calculateDuration(booking.arrivalDate, booking.departureDate);
  return <div className="flex flex-col min-h-full bg-gray-50" data-id="element-156">
      <Header title="Mijn Boekingen" showBackButton data-id="element-157" />
      <div className="p-4" data-id="element-158">
        <div className="bg-white rounded-lg shadow-sm p-4 mb-4" data-id="element-159">
          <div className="flex justify-between items-center mb-4" data-id="element-160">
            <h2 className="text-lg font-bold" data-id="element-161">Huidige Boeking</h2>
            <span className="text-sm bg-green-100 text-green-800 py-1 px-2 rounded-full flex items-center" data-id="element-162">
              <CheckCircleIcon size={14} className="mr-1" data-id="element-163" />
              Bevestigd
            </span>
          </div>
          <div className="border-b pb-3 mb-3" data-id="element-164">
            <div className="flex items-center mb-3" data-id="element-165">
              <CalendarIcon size={18} className="text-[#f9b30f] mr-2" data-id="element-166" />
              <div data-id="element-167">
                <p className="text-sm font-medium" data-id="element-168">Verblijfsperiode</p>
                <p className="text-sm" data-id="element-169">
                  {arrivalDate} - {departureDate} ({duration} nachten)
                </p>
              </div>
            </div>
            <div className="flex items-center mb-3" data-id="element-170">
              <UsersIcon size={18} className="text-[#f9b30f] mr-2" data-id="element-171" />
              <div data-id="element-172">
                <p className="text-sm font-medium" data-id="element-173">Aantal personen</p>
                <p className="text-sm" data-id="element-174">{booking.persons} personen</p>
              </div>
            </div>
            <div className="flex items-center" data-id="element-175">
              <HomeIcon size={18} className="text-[#f9b30f] mr-2" data-id="element-176" />
              <div data-id="element-177">
                <p className="text-sm font-medium" data-id="element-178">Accommodatie</p>
                <p className="text-sm" data-id="element-179">{booking.accommodation}</p>
                <p className="text-xs text-gray-500" data-id="element-180">{booking.location}</p>
              </div>
            </div>
          </div>
          <div className="mb-4" data-id="element-181">
            <div className="flex justify-between items-center mb-2" data-id="element-182">
              <p className="text-sm font-medium" data-id="element-183">Extra's</p>
              <button className="text-xs text-[#f9b30f]" onClick={() => setShowExtras(!showExtras)} data-id="element-184">
                {showExtras ? 'Verbergen' : 'Alles tonen'}
              </button>
            </div>
            <ul className="text-sm" data-id="element-185">
              {booking.extras.slice(0, showExtras ? booking.extras.length : 2).map((extra, index) => <li key={index} className="flex items-center justify-between mb-1" data-id="element-186">
                    <div className="flex items-center" data-id="element-187">
                      <span className="w-2 h-2 bg-[#f9b30f] rounded-full mr-2" data-id="element-188"></span>
                      {extra.name}
                    </div>
                    <span className="text-gray-600" data-id="element-189">€{extra.price}</span>
                  </li>)}
              {!showExtras && booking.extras.length > 2 && <li className="text-xs text-gray-500 ml-4" data-id="element-190">
                  +{booking.extras.length - 2} meer...
                </li>}
            </ul>
          </div>
          <div className="bg-gray-50 p-3 rounded-lg mb-4" data-id="element-191">
            <div className="flex justify-between mb-1" data-id="element-192">
              <span className="text-sm" data-id="element-193">Accommodatie</span>
              <span className="text-sm" data-id="element-194">€{booking.price}</span>
            </div>
            <div className="flex justify-between mb-1" data-id="element-195">
              <span className="text-sm" data-id="element-196">Extra's</span>
              <span className="text-sm" data-id="element-197">€{totalExtras}</span>
            </div>
            <div className="flex justify-between font-medium pt-2 border-t border-gray-200 mt-2" data-id="element-198">
              <span data-id="element-199">Totaal</span>
              <span data-id="element-200">€{totalPrice}</span>
            </div>
          </div>
          <button className="w-full mt-2 bg-[#f9b30f] text-black py-2 px-4 rounded-lg flex items-center justify-center" data-id="element-201">
            <PlusIcon size={18} className="mr-1" data-id="element-202" />
            Extra's toevoegen
          </button>
        </div>
        <div className="bg-white rounded-lg shadow-sm p-4 mb-4" data-id="element-203">
          <h3 className="font-medium mb-3" data-id="element-204">Aankomst & Vertrek</h3>
          <div className="space-y-3" data-id="element-205">
            <div className="flex items-start" data-id="element-206">
              <ClockIcon size={18} className="text-[#f9b30f] mr-2 mt-0.5" data-id="element-207" />
              <div data-id="element-208">
                <p className="text-sm font-medium" data-id="element-209">Aankomst op {arrivalDate}</p>
                <p className="text-sm text-gray-600" data-id="element-210">
                  Check-in vanaf 14:00 bij de receptie
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-211">
              <ClockIcon size={18} className="text-[#f9b30f] mr-2 mt-0.5" data-id="element-212" />
              <div data-id="element-213">
                <p className="text-sm font-medium" data-id="element-214">
                  Vertrek op {departureDate}
                </p>
                <p className="text-sm text-gray-600" data-id="element-215">Check-out voor 11:00</p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-216">
          <div className="flex justify-between items-center mb-3" data-id="element-217">
            <h3 className="font-medium" data-id="element-218">Boekingsgegevens</h3>
            <span className="text-xs text-gray-500" data-id="element-219">Boeking #{booking.id}</span>
          </div>
          <div className="space-y-3" data-id="element-220">
            <div className="flex items-start" data-id="element-221">
              <CreditCardIcon size={18} className="text-[#f9b30f] mr-2 mt-0.5" data-id="element-222" />
              <div data-id="element-223">
                <p className="text-sm font-medium" data-id="element-224">Betaling</p>
                <p className="text-sm text-gray-600" data-id="element-225">Volledig betaald</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-226">
              <InfoIcon size={18} className="text-[#f9b30f] mr-2 mt-0.5" data-id="element-227" />
              <div data-id="element-228">
                <p className="text-sm" data-id="element-229">Heb je vragen over je boeking?</p>
                <button className="text-sm text-[#f9b30f] font-medium" data-id="element-230">
                  Neem contact op met de receptie
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Bookings;